<div class="col-12">
    <div *ngIf="!isDone" class="partners">
        <div class="partners__bg partners__bg--uitf">
            <h4 class="partners__header">CLIENT ONBOARDING</h4>
            <h5 class="partners__subtext">Need to submit your client KYCs? <br/>Start by uploading all your client details to facilitate a smoother onboarding process.</h5>
        </div>
        <div class="container">
            <div class="row  justify-content-center">
                <div class="box box--login col-12 col-lg-8">
                    <div class="box__cont">
                        <!-- <div class="box__title box__title--otp">
                            <h1>Forgot Password</h1>
                            <h2>verify your account</h2>
                        </div> -->
                        <div class="box__form" *ngIf="localStorageService.get('companyCode') ==='PRUAGENTS'">
                            <div class="col-12 box__field box__field--otp">
                                <div class="col-12 box__field">
                                    <div class="box__text text-center">
                                        <p><b>Need a form to enlist your client?</b></p>
                                        <p>Use ATRAM's online enrollment form to directly register your client anywhere.</p>
                                    </div>
                                    <div class="col-12 text-center" style="padding:30px 0">
                                        <atram-button   buttonType="default"
                                                        label="Enroll a Client"
                                                        componentClass="btn-submit"
                                                        (on-click)="goToForm()">
                                        </atram-button>
                                    </div>
                                    <hr/>
                                    <div class="box__text text-center">
                                        <p><b>Do you have your clients documents with your client?</b></p>
                                        <p>Upload your customers files thru our portal.</p>
                                    </div>
                                    <div class="f-form_input">
                                        <input style="display:none;" #uploader multiple type="file" [accept]="'.' + attachmentFileTypeSupported.join(',.')" (change)="fileAttach($event)" />
                                        <div class="col-12 text-center" style="padding:30px 0">
                                            <atram-button label="Select Files"
                                                            componentClass="btn-submit"
                                                            (on-click)="uploader.click()">
                                            </atram-button>
                                        </div>
                                    </div>
                                    <div class="box__text text-center">
                                        The maximum total file size you can send is only <b>15MB</b>. Only file types accepted are the ff:  <b>XLS, XLSX, CSV, JPG, JPEG, PNG, PDF</b>. Make sure to use the format provided, to avoid multiple uploads and delays. 
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="box__form" *ngIf="localStorageService.get('companyCode') !=='PRUAGENTS'">
                            <div class="col-12 box__field box__field--otp">
                                <div class="col-12 box__field">
                                    <div class="box__text text-center">
                                        The maximum total file size you can send is only <b>15MB</b>. Only file types accepted are the ff:  <b>XLS, XLSX, CSV, JPG, JPEG, PNG, PDF</b>. Make sure to use the format provided, to avoid multiple uploads and delays. 
                                    </div>
                                    <div class="f-form_input">
                                        <input style="display:none;" #uploader multiple type="file" [accept]="'.' + attachmentFileTypeSupported.join(',.')" (change)="fileAttach($event)" />
                                        <div class="col-12" style="padding-top:30px">
                                            <atram-button label="Choose Files"
                                                            componentClass="btn-submit"
                                                            (on-click)="uploader.click()">
                                            </atram-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="file-table">
                <div *ngIf="attachmentFiles.length > 0" class="row justify-content-center">
                    <div class="col-12 col-lg-8">
                        <div class="row file-table__options">
                            <div class="col-12 col-sm-6">
                                <h4>You have selected {{attachmentFiles.length}} file<span *ngIf="attachmentFiles.length > 1">s</span></h4>
                            </div>
                            <div class="col-12 text-center">
                                <div class="buttons buttons--dual">
                                    <div class="row">
                                        <div class="buttons__first col-12 col-sm-6">
                                            <atram-button buttonType="default"
                                                label="Cancel All"
                                                componentClass="btn-submit"
                                                (on-click)="cancelAll()">
                                            </atram-button>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <atram-button label="Upload Now"
                                                componentClass="btn-submit"
                                                (on-click)="proceed()">
                                            </atram-button>  
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row file-table__headers">
                            <div class="col-6">
                                <p>File Name</p>
                            </div>
                            <div class="col-4">
                                <p>Size</p>
                            </div>
                        </div>
                        <hr> 
                        <!-- <div *ngIf="hasError">
                            <ng-container *ngFor="let file of unsuccessfulList; let i = index">
                                <div class="row file-table__body">
                                    <div class="col-6">
                                        <p>{{file.file_name}}</p>
                                    </div>
                                    <div class="col-4">
                                        <p>{{file.file_size}}</p>
                                    </div>
                                    <div class="col-2 text-right">
                                        <atram-button remove-component-tag
                                                    buttonType="link"
                                                    title="Search"
                                                    componentClass="btn-ico"
                                                    (on-click)="removeFile(i)"
                                                    icon="atram-ico before ico-close ico-1x ico-active">
                                        </atram-button>
                                    </div>
                                </div>
                                <hr>    
                            </ng-container> 
                        </div>-->
                        <div>
                            <ng-container *ngFor="let file of attachmentFiles; let i = index">
                                <div *ngIf="file['isSuccess'] == undefined || file['isSucess'] === false" class="row file-table__body">
                                     <div class="col-6">
                                        <p data-title="{{file.file_name}}">{{file.file_name}}</p>
                                    </div>
                                    <div class="col-4">
                                        <p>{{file.file_size}}</p>
                                    </div>
                                    <div class="col-2 text-right">
                                        <atram-button remove-component-tag
                                                    buttonType="link"
                                                    title="Search"
                                                    componentClass="btn-ico"
                                                    (on-click)="removeFile(i,file.file_size)"
                                                    icon="atram-ico before ico-close ico-1x ico-active">
                                        </atram-button>
                                    </div>
                                </div>
                                <hr>    
                            </ng-container>
                        </div>              
                    </div>
                </div>
            </div>
        </div>  
    </div>
    <div *ngIf="isDone && !isIncomplete" class="result">
        <div class="result__top">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-6 text-center">
                        <img [src]="'../../assets/images/icon-notification-success.svg'" alt="success" class="result__img"/>
                        <h1>Your file(s) have been Successfully Sent!</h1>
                        <h2>The delivery was made on</h2>
                        <p class="result__date">{{emailedDate}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="result__bottom">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-6">
                        <div class="row result__headers">
                            <div class="col-9">
                                <p>File Name</p>
                            </div>
                            <div class="col-3 text-right">
                                <p>Size</p>
                            </div>
                        </div>
                        <hr>  
                        <ng-container *ngFor="let file of successfulList; let i = index">
                            <div class="row result__body">
                                <div class="col-9">
                                    <p data-title="{{file.file_name}}">{{file.file_name}}</p>
                                </div>
                                <div class="col-3 text-right">
                                    <p>{{file.file_size}}</p>
                                </div>
                            </div>
                            <hr>    
                        </ng-container>
                        <div class="row justify-content-center">
                            <div class="col-12 col-sm-6 text-center" style="margin-bottom:30px">
                                <div class="buttons">
                                    <atram-button label="Return to Dashboard"
                                                    componentClass="btn-submit"
                                                    (on-click)="goToHome()">
                                    </atram-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>  
        </div>
    </div>
    <div *ngIf="isDone && isIncomplete" class="result">
        <div class="result__top">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-6 text-center">
                        <img [src]="'../../assets/images/icon-notification-warning.svg'" alt="success" class="result__img"/>
                        <h1>Not All your files were uploaded</h1>
                        <h2>The delivery was made on</h2>
                        <p class="result__date">{{emailedDate}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="result__bottom">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-6">
                        <div class="row result__headers">
                            <div class="col-6">
                                <p>File Name</p>
                            </div>
                            <div class="col-3 text-center">
                                <p>Size</p>
                            </div>
                            <div class="col-3 text-right">
                                <p>Upload Status</p>
                            </div>
                        </div>
                        <hr>  
                        <ng-container *ngFor="let file of attachmentFiles; let i = index">
                            <div class="row result__body">
                                <div class="col-6">
                                    <p>{{file.file_name}}</p>
                                </div>
                                <div class="col-3 text-right">
                                    <p>{{file.file_size}}</p>
                                </div>
                                <div class="col-3 text-right">
                                    <p class="green-cont" *ngIf="file.isSuccess">Uploaded</p>
                                    <p class="red-cont" *ngIf="!file.isSuccess">Upload Error</p>
                                </div>
                            </div>
                            <hr>    
                        </ng-container>
                        <div class="row justify-content-center">
                            <div class="col-12 col-sm-6 text-center" style="margin-bottom:30px">
                                <div class="buttons">
                                    <atram-button label="Return to Home"
                                                    componentClass="btn-submit"
                                                    (on-click)="goToHome()">
                                    </atram-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        </div>
    </div>
</div>
<atram-modal #atramModal></atram-modal>